import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  FormControlLabel,
  Switch as MSwitch
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 0,
    marginRight: 0
  },
  label: {
    fontSize: "0.85rem",
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1)
  }
}));

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 24,
    padding: 0,
    margin: theme.spacing(0.5, 0)
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[400],
    "&$checked": {
      transform: "translateX(18px)",
      color: theme.palette.primary.main,
      "& + $track": {
        backgroundColor: theme.palette.primary.main,
        opacity: ".6",
        border: "none"
      }
    },
    "&$disabled": {
      color: `${theme.palette.primary.main}80`,
      "& + $track": {
        backgroundColor: `${theme.palette.primary.main}40 !important`,
        opacity: 1
      }
    },
    "&:not($checked):not($disabled) + $track": {
      backgroundColor: theme.palette.grey[300]
    }
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
  },
  track: {
    borderRadius: 12,
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
    transition: theme.transitions.create(
      ["background-color", "border"],
      {
        duration: theme.transitions.duration.shortest
      }
    )
  },
  checked: {},
  disabled: {}
}))(MSwitch);

const Switch = ({ name, label, disabled, onChange, className }) => {
  const classes = useStyles();

  return (
    <Field name={name}>
      {({ field }) => (
        <FormControlLabel
          className={`${classes.root} ${className}`}
          classes={{ label: classes.label }}
          control={
            <CustomSwitch
              name={name}
              checked={field.value}
              disabled={disabled}
              disableRipple
              {...field}
              onChange={(e) => {
                field.onChange(e);
                if (typeof onChange === "function")
                  onChange(e.target.checked);
              }}
            />
          }
          label={label}
        />
      )}
    </Field>
  );
};

Switch.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string
};

Switch.defaultProps = {
  name: "",
  label: "",
  disabled: false,
  onChange: null,
  className: ""
};

export default Switch;
